var $74acab58a515de50$exports = {};
document.addEventListener("DOMContentLoaded", ()=>{
    const faqContainer = document.getElementById("faq-container");
    const faqSearchInput = document.getElementById("faq-search");
    const quickCategories = document.querySelectorAll(".category-card-mini");
    const faqsData = [
        // --- Account Management ---
        {
            category: "Account Management",
            question: "How do I start a new organization?",
            answer: 'Begin by clicking "Sign Up" on our landing page. After entering your organization details and completing dual-factor OTP verification (Email & Phone), our super-admin team will review your request. Once approved, you can log in, select your subscription tier, and start managing your Organization instantly. For direct assistance, email luckybasera123@gmail.com.'
        },
        {
            category: "Account Management",
            question: "Can I add multiple administrators?",
            answer: 'Yes. Premium and Enterprise organizations can have multiple administrators. You can manage their roles and access levels directly from the "Organization Management" portal after the Chairman approves their initial registration.'
        },
        {
            category: "Account Management",
            question: "Is it possible to recover a lost password?",
            answer: 'Absolutely. Use the "Forgot Password" link on the login page. You will need to verify your identity via OTP sent to your registered contact method, after which you can securely set a new password for your Dashboard.'
        },
        {
            category: "Account Management",
            question: "How can I change my profile information?",
            answer: 'You can update your personal details, including your email address and password, from the "Profile Settings" section in your dashboard. For security reasons, changes to your primary contact information may require re-verification.'
        },
        {
            category: "Account Management",
            question: "How do I delete my account?",
            answer: 'To request account deletion, navigate to the "Delete Account" page. This action is irreversible and requires confirmation. Your request will be sent to the Chairman for final approval. Once approved, all your data will be permanently removed from our system.'
        },
        // --- Member & Schedule Management ---
        {
            category: "Member & Schedule Management",
            question: "What is the most efficient way to add members?",
            answer: 'While you can add members individually through the "User Management" dashboard, the fastest way for large Organizations is through our "Bulk Import" feature. Simply upload a CSV file, and our system will instantly generate unique IDs and QR codes for your entire staff and student body.'
        },
        {
            category: "Member & Schedule Management",
            question: "How does the timetable logic work?",
            answer: "LukaIN utilizes an advanced Genetic Algorithm (GA) engine for timetabling. It autonomously calculates the best possible schedule based on staff availability, subject requirements, and classroom constraints. Schedules can be refined manually through the Timetable Management portal."
        },
        {
            category: "Member & Schedule Management",
            question: "Can I customize member roles and permissions?",
            answer: "Yes, LukaIN provides flexible role-based access control. Administrators can define custom roles and assign specific permissions to different types of users (e.g., teachers, students, support staff) to ensure data security and operational efficiency."
        },
        {
            category: "Member & Schedule Management",
            question: "How do I manage multi-branch or multi-location Organizations?",
            answer: "Our Enterprise solution is designed for multi-branch organizations. It offers centralized management for all your locations, allowing you to oversee operations, attendance, and reporting from a single, unified dashboard."
        },
        // --- Attendance & Scheduling ---
        {
            category: "Attendance & Scheduling",
            question: "Is the QR attendance tamper-proof?",
            answer: "Yes. Our QR engine uses encrypted member codes and real-time finalization windows. Each scan is timestamped according to your Organization's specific timezone, preventing backdated entries and ensuring 100% accurate reporting."
        },
        {
            category: "Attendance & Scheduling",
            question: "How are substitutes assigned?",
            answer: 'When a staff member is marked absent, the "Smart Substitution" engine scans your live timetable. It identifies present and free members for that specific period and suggests the best match. Admins can accept the suggestion with one click or perform a manual override.'
        },
        {
            category: "Attendance & Scheduling",
            question: "What types of attendance reports are available?",
            answer: "LukaIN offers a variety of customizable attendance reports, including daily summaries, monthly aggregates, and individual member attendance records. Reports can be filtered by date range, department, and member type, and exported in multiple formats."
        },
        {
            category: "Attendance & Scheduling",
            question: "Can I integrate LukaIN with my existing calendar system?",
            answer: "Currently, direct integration with external calendar systems is not available. However, you can export your timetable data in CSV or PDF formats, which can then be imported into most popular calendar applications."
        },
        // --- Billing & Subscriptions ---
        {
            category: "Billing & Subscriptions",
            question: "Do you support international currencies?",
            answer: "Yes. LukaIN features a Professional currency switcher on the pricing page, allowing you to view plans and manage billing in both INR (\u20B9) and USD ($) seamlessly."
        },
        {
            category: "Billing & Subscriptions",
            question: "What is the refund policy?",
            answer: "We offer a flexible billing system. Upgrades are immediate with prorated credits. Downgrades take effect at the start of your next cycle. For specific refund inquiries, please contact luckybasera123@gmail.com."
        },
        {
            category: "Billing & Subscriptions",
            question: "How does the free trial work?",
            answer: "New organizations automatically start on a free trial, which typically lasts for 14 days or a certain number of member registrations. During the trial, you have full access to key features to evaluate LukaIN for your needs. No credit card is required to start."
        },
        {
            category: "Billing & Subscriptions",
            question: "What payment methods do you accept?",
            answer: "We accept all major credit and debit cards, as well as net banking and UPI payments in India. For Enterprise plans, custom invoicing and bank transfers are available."
        },
        // --- Security & Technical Support ---
        {
            category: "Security & Technical Support",
            question: "Where is my data stored?",
            answer: "Your data is secured in high-performance PostgreSQL databases hosted on reliable cloud infrastructure. We implement stateless JWT authentication and full system audit logs to ensure your organizational data is always protected and transparent."
        },
        {
            category: "Security & Technical Support",
            question: "How do I contact support for urgent issues?",
            answer: 'For the fastest assistance, use our "Support Portal" to submit a ticket. You can track your request status using only your email. For direct inquiries, you can always reach us at luckybasera123@gmail.com.'
        },
        {
            category: "Security & Technical Support",
            question: "Is LukaIN mobile-friendly?",
            answer: "Yes, LukaIN is built with a responsive design, ensuring optimal performance and usability across all devices, including desktops, tablets, and smartphones. Access your dashboard and features seamlessly from anywhere."
        }
    ];
    function highlightText(text, filter) {
        if (!filter) return text;
        const regex = new RegExp(`(${filter})`, "gi");
        return text.replace(regex, '<span class="highlight-match">$1</span>');
    }
    function renderFaqs(filterText = "") {
        if (!faqContainer) return;
        faqContainer.innerHTML = "";
        const lowerCaseFilterText = filterText.toLowerCase();
        const categories = [
            ...new Set(faqsData.map((faq)=>faq.category))
        ];
        let hasResults = false;
        categories.forEach((category)=>{
            const categoryFaqs = faqsData.filter((faq)=>faq.category === category && (faq.question.toLowerCase().includes(lowerCaseFilterText) || faq.answer.toLowerCase().includes(lowerCaseFilterText)));
            if (categoryFaqs.length > 0) {
                hasResults = true;
                const categoryContainer = document.createElement("div");
                categoryContainer.className = "faq-category";
                const categoryTitle = document.createElement("h2");
                categoryTitle.className = "faq-category-title";
                categoryTitle.textContent = category;
                categoryContainer.appendChild(categoryTitle);
                categoryFaqs.forEach((faq)=>{
                    const faqItem = document.createElement("div");
                    faqItem.className = "faq-item";
                    const questionDiv = document.createElement("div");
                    questionDiv.className = "faq-question";
                    questionDiv.innerHTML = `<span>${highlightText(faq.question, filterText)}</span><i class="fas fa-chevron-down toggle-icon"></i>`;
                    const answerDiv = document.createElement("div");
                    answerDiv.className = "faq-answer";
                    answerDiv.innerHTML = `<p>${highlightText(faq.answer, filterText)}</p>`;
                    questionDiv.addEventListener("click", ()=>{
                        faqItem.classList.toggle("active");
                    // Optional: Close other items in the same category for elite focus
                    // categoryContainer.querySelectorAll('.faq-item.active').forEach(item => {
                    //     if (item !== faqItem) item.classList.remove('active');
                    // });
                    });
                    faqItem.appendChild(questionDiv);
                    faqItem.appendChild(answerDiv);
                    categoryContainer.appendChild(faqItem);
                });
                faqContainer.appendChild(categoryContainer);
            }
        });
        if (!hasResults) faqContainer.innerHTML = '<div class="no-results"><i class="fas fa-exclamation-triangle"></i><p>No matching FAQs found. Try a different search term.</p></div>';
    }
    renderFaqs();
    if (faqSearchInput) faqSearchInput.addEventListener("input", (e)=>{
        renderFaqs(e.target.value);
    });
    // Quick Category Navigation
    quickCategories.forEach((card)=>{
        card.addEventListener("click", ()=>{
            const targetCategory = card.getAttribute("data-category");
            // Remove active from all cards
            quickCategories.forEach((c)=>c.classList.remove("active"));
            // Add active to the clicked card
            card.classList.add("active");
            const categoryTitles = document.querySelectorAll(".faq-category-title");
            for (const title of categoryTitles)if (title.textContent.includes(targetCategory)) {
                title.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                }); // Scroll to top of category
                break;
            }
        });
    });
});


//# sourceMappingURL=help.734fa2cd.js.map
